import { render, staticRenderFns } from "./portal_Product-customization.vue?vue&type=template&id=14b6dbee&"
import script from "./portal_Product-customization.vue?vue&type=script&lang=js&"
export * from "./portal_Product-customization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports